import React from 'react'
import styled from 'styled-components'

export type THeadingLevel = '1' | '2' | '3' | '4'

export enum EHeadingLevels {
  h1 = '1',
  h2 = '2',
  h3 = '3',
  h4 = '4',
}

const StyledHeading = styled.h1<{ level: THeadingLevel; textColor: 'primary' | 'secondary' }>`
  color: ${({ textColor, theme }) =>
    textColor === 'primary' ? theme.colors.text.textPrimary : theme.colors.text.textSecondary};
  ${({ level, theme }) => {
    if (level === '1') return theme.textSizes.desktop.h1
    if (level === '2') return theme.textSizes.desktop.h2
    if (level === '3') return theme.textSizes.desktop.h3
    if (level === '4') return theme.textSizes.desktop.h4
  }};
`

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: THeadingLevel
  textColor?: 'primary' | 'secondary'
}

export const Heading = ({ level = '1', textColor = 'primary', children, ...restProps }: HeadingProps): JSX.Element => (
  <StyledHeading as={`h${level}` as never} level={level} textColor={textColor} {...restProps}>
    {children}
  </StyledHeading>
)
